/** Format one monetary value with the Palestinian shekel symbol. */
export const formatMoney = (value) => {
    const numericValue = Number(value ?? 0);
    const safeValue = Number.isFinite(numericValue) ? numericValue : 0;

    return `${safeValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} ₪`;
};
